import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import Confetti from "react-confetti";
import "./CelebrationPopup.css";

const CelebrationPopup = ({ isOpen, onClose, type = "success", title, message, btnText }) => {
    // Determine button text if not provided
    const buttonLabel = btnText || (type === "success" ? "Awesome!" : "Okay");

    return (
        <AnimatePresence>
            {isOpen && (
                <div className="popup-overlay" onClick={onClose}>
                    {/* 🎉 Show Confetti ONLY if type is success */}
                    {type === "success" && (
                        <Confetti
                            width={window.innerWidth}
                            height={window.innerHeight}
                            recycle={false}
                            numberOfPieces={500}
                            gravity={0.2}
                        />
                    )}

                    <motion.div
                        className={`popup-content ${type}`}
                        initial={{ scale: 0.5, opacity: 0, y: 50 }}
                        animate={{ scale: 1, opacity: 1, y: 0 }}
                        exit={{ scale: 0.5, opacity: 0, y: 50 }}
                        transition={{ type: "spring", stiffness: 300, damping: 25 }}
                        onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside box
                    >
                        <div className="popup-icon-box">
                            <i className={`fa-solid ${type === "success" ? "fa-check" : "fa-exclamation"}`}></i>
                        </div>
                        
                        <h2>{title}</h2>
                        <p>{message}</p>
                        
                        <button className="popup-btn" onClick={onClose}>
                            {buttonLabel}
                        </button>
                    </motion.div>
                </div>
            )}
        </AnimatePresence>
    );
};

export default CelebrationPopup;